import { getObtainConfirm, searchObtainWithReject, } from "../api/generated/wrappers/obtain";
import { getObtainConfirmDetail } from "../api/generated/wrappers/obtain";
import { getObtainHistoryVersions } from "../api/generated/wrappers/obtain";
import { getObtainHistoryVersionData } from "../api/generated/wrappers/obtain";
import { createQueryKeys } from "./create-query-keys";
const obtainQueryKeys = createQueryKeys("obtain", {
    confirm: (searchCardInputs) => ({
        queryKey: ["confirm"],
        queryFn: async () => await getObtainConfirm(searchCardInputs),
    }),
    confirmWithReject: (searchCardInputs) => ({
        queryKey: ["confirmWithReject"],
        queryFn: async () => await searchObtainWithReject(searchCardInputs),
    }),
    confirmDetail: (id) => ({
        queryKey: ["confirmDetail", id],
        queryFn: async () => await getObtainConfirmDetail(id),
    }),
    historyVersions: (originId) => ({
        queryKey: ["historyVersions", originId],
        queryFn: async () => await getObtainHistoryVersions(originId),
    }),
    historyVersionData: (historyId) => ({
        queryKey: ["historyVersionData", historyId],
        queryFn: async () => await getObtainHistoryVersionData(historyId),
    }),
});
export default obtainQueryKeys;
